// extracted by mini-css-extract-plugin
export default {"page":"finance-deposit-list_page__GEeHN","grid":"finance-deposit-list_grid__MqWvq","total":"finance-deposit-list_total__5JB6J"};